import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aee4e9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute w-full h-full left-0 top-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://customer-vt66666ts449vzd9.cloudflarestream.com/221a3bf6a05ba6b923c222ea5f9a4651/manifest/video.m3u8",
  type: "application/x-mpegURL"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "font-serif" }
const _hoisted_5 = { class: "mt-[150px] xxs:mt-[175px] mb-30px text-headingLg md:text-headingXl lg:text-heading1xl" }
const _hoisted_6 = { class: "text-center body-Lg sm:text-bodyXl lg:text-body2xl" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "font-serif text-center" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "mb-30px text-center text-headingLg lg:text-heading1xl" }
const _hoisted_11 = { class: "text-bodyLg sm:text-bodyXl lg:text-body2xl" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "text-bodyMd sm:text-base max-w-[600px]" }
const _hoisted_14 = { class: "mt-50px sm:mt-[70px] mb-100px" }
const _hoisted_15 = { class: "uppercase font-medium" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = { class: "uppercase font-medium" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "mb-50px sm:mb-100px" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "text-bodyMd sm:text-base mb-[150px] xxs:mb-[175px] sm:mb-[250px] text-center" }
const _hoisted_23 = { class: "uppercase font-medium mb-6" }
const _hoisted_24 = ["innerHTML"]

import useLanguage from '@/composables/useLanguage'
import { MJPSection, MJPSectionData } from './types'
import BottomGradient from '../general/BottomGradient.vue'
import ScrollProgress from '../general/ScrollProgress.vue'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'
import usePreviousSection from '@/composables/mjp/usePreviousSection'
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'
import { useEventBus } from '@vueuse/core'
import Hls from 'hls.js'
import { gsap } from 'gsap'
import { ScrollToPlugin } from '@/assets/js/ScrollToPlugin.min.js'

interface Props {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCreditsSection',
  props: {
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    forward: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}

gsap.registerPlugin(ScrollToPlugin)


const text = useLanguage(props.currentSection)
const sectionChangedBus = useEventBus('section-changed')
const video: Ref<HTMLVideoElement | null> = ref(null)
const scrollContainer: Ref<HTMLElement | null> = ref(null)
const contentElement: Ref<HTMLElement | null> = ref(null)
const state = reactive({
  scrollProgress: 0,
  prefersReducedMotion: matchMedia('(prefers-reduced-motion)').matches,
})
const windowSize = {
  x: window.innerWidth,
  y: window.innerHeight,
}
const keyCodes = {
  UpArrow: 38,
  DownArrow: 40,
}

const handleResize = () => {
  updateWindowSize()
}

const updateWindowSize = () => {
  windowSize.x = window.innerWidth
  windowSize.y = window.innerHeight
}

const updateScrollProgress = () => {
  if (scrollContainer.value && contentElement.value) {
    const curY = scrollContainer.value.scrollTop
    const postHeight = scrollContainer.value.offsetHeight
    const scrollHeight = contentElement.value.offsetHeight
    state.scrollProgress = curY / (scrollHeight - postHeight)
    if (state.scrollProgress <= 0) {
      sectionChangedBus.emit({
        section: usePreviousSection(props.sectionData.section),
        pageNumber: 0,
        forward: !props.sectionData.goBackwardsToPreviousSection,
        lastSection: props.currentSection,
      })
    }
  } else {
    state.scrollProgress = 0
  }
}

const pageRangeIsActive = (lo, hi) => {
  return (
    props.currentSection == props.sectionData.section &&
    props.currentSectionHasLoaded
  )
}

const opacityForPageRange = (lo, hi) => {
  return props.currentSection == props.sectionData.section &&
    props.currentSectionHasLoaded
    ? 1
    : 0
}

const handleKeyDown = (e) => {
  var keyCode = e.keyCode || e.which
  switch (keyCode) {
    case keyCodes.UpArrow:
      previousPage()
      break

    case keyCodes.DownArrow:
      nextPage()
      break

    default:
      break
  }
}

const previousPage = () => {
  if (scrollContainer.value) {
    let scrollDestination =
      scrollContainer.value.scrollTop - windowSize.y * 0.66
    if (scrollContainer.value.scrollTop > 5) {
      scrollDestination = Math.max(5, scrollDestination)
    }
    gsap.to(scrollContainer.value, {
      scrollTo: scrollDestination,
      duration: 1,
    })
  }
}

const nextPage = () => {
  if (scrollContainer.value) {
    gsap.to(scrollContainer.value, {
      scrollTo: scrollContainer.value.scrollTop + windowSize.y * 0.66,
      duration: 1,
    })
  }
}

onMounted(() => {
  if (video.value) {
    const config = {
      capLevelToPlayerSize: false,
      startLevel: 3,
    }
    let hls = new Hls(config)
    let stream =
      'https://customer-vt66666ts449vzd9.cloudflarestream.com/221a3bf6a05ba6b923c222ea5f9a4651/manifest/video.m3u8'
    hls.loadSource(stream)
    hls.attachMedia(video.value)
    hls.on(Hls.Events.LEVEL_SWITCHED, function (result) {
      console.log('Level switched', hls.currentLevel)
    })
    hls.on(Hls.Events.MANIFEST_PARSED, function () {
      console.log(hls.config)
      video.value?.play()
    })
  }
  document.addEventListener('keydown', handleKeyDown, false)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyDown)
})

return (_ctx: any,_cache: any) => {
  const _directive_resize = _resolveDirective("resize")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveBackgroundImage, {
      id: "credits-bg",
      dir: "mjp",
      sm: "credits-bg-sm.jpg",
      md: "credits-bg-md.jpg",
      lg: "credits-bg-lg.jpg",
      alt: _unref(text).altText,
      isActive: pageRangeIsActive(0, 99)
    }, null, 8, ["alt", "isActive"]),
    (!state.prefersReducedMotion)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          ref_key: "video",
          ref: video,
          id: "credits-bg-video",
          class: "border-none absolute bg-slateGray object-cover top-0 left-0 w-full h-full overflow-hidden",
          autoplay: "",
          muted: "",
          loop: "",
          playsinline: ""
        }, _hoisted_3, 512))
      : _createCommentVNode("", true),
    _createVNode(BottomGradient),
    _createElementVNode("div", {
      id: "creditsScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "w-full h-full overflow-y-auto text-white text-center pointer-events-auto",
      style: _normalizeStyle({
        'mask-image':
          'linear-gradient(0deg, rgba(0,0,0,0) 15%, rgba(0,0,0,1) 25%, rgba(0,0,0,1) 75%, rgba(0,0,0,0) 85%)',
        opacity: opacityForPageRange(0, 99),
      }),
      onScroll: updateScrollProgress
    }, [
      _createElementVNode("div", {
        ref_key: "contentElement",
        ref: contentElement,
        class: "w-full flex flex-col items-center px-6 mx-auto sm:w-2/3 text-center"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(text).landWaterAcknowledgement), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).statement, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: _normalizeClass(["mb-30px", {
                'pointer-events-auto': index == 3,
              }]),
                innerHTML: paragraph
              }, null, 10, _hoisted_7))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "w-150px sm:w-[274px] my-50px mx-auto sm:my-100px",
            src: "/images/mjp/livingInfrastructureBraid.png",
            alt: _unref(text).livingInfraAlt
          }, null, 8, _hoisted_9),
          _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(text).creditsTitle), 1),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).credits, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "mb-30px",
                innerHTML: paragraph
              }, null, 8, _hoisted_12))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h2", _hoisted_15, _toDisplayString(_unref(text).feedbackTitle), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).feedbackCredits, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                innerHTML: paragraph
              }, null, 8, _hoisted_16))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(text).artMediaTitle), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).artMediaCredits, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                innerHTML: paragraph
              }, null, 8, _hoisted_19))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).additionalCredits, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "mb-5",
                key: index,
                innerHTML: paragraph
              }, null, 8, _hoisted_21))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("h2", _hoisted_23, _toDisplayString(_unref(text).referencesTitle), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(text).references, (reference, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "mb-2",
              innerHTML: reference
            }, null, 8, _hoisted_24))
          }), 128))
        ])
      ], 512)
    ], 36),
    _createVNode(ScrollProgress, {
      scrollProgress: state.scrollProgress
    }, null, 8, ["scrollProgress"])
  ])), [
    [_directive_resize, handleResize]
  ])
}
}

})